/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Difference_Company_AddressInputs */

const et_difference_company_address = /** @type {(inputs: Difference_Company_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näidis Aadress 12, 10111 Tallinn`)
};

const en_difference_company_address = /** @type {(inputs: Difference_Company_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sample Address 12, 10111 Tallinn`)
};

/**
* | output |
* | --- |
* | "Sample Address 12, 10111 Tallinn" |
*
* @param {Difference_Company_AddressInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const difference_company_address = /** @type {((inputs?: Difference_Company_AddressInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Difference_Company_AddressInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_difference_company_address(inputs)
	return en_difference_company_address(inputs)
});